import * as actions from './workflow-node.actions';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkflowNodeModel } from '@smarttask-common/src/lib/models/Workflow/node/core/WorkflowNodeModel';

export const workflowNodeAdapter = createEntityAdapter<WorkflowNodeModel>({
    selectId: (x) => x.node_id,
});

export interface WorkflowNodeState extends EntityState<WorkflowNodeModel> {
    selected_node_id: string;
}

export const initialState: WorkflowNodeState = workflowNodeAdapter.getInitialState({
    selected_node_id: undefined,
});

export function WorkflowNodeReducers(state: WorkflowNodeState = initialState, action: actions.WorkflowNodeActions) {
    switch (action.type) {
        case actions.WorkflowNodeActionTypes.UPDATE_SELECTED_ID:
            return { ...state, selected_node_id: action.selected_node_id };

        case actions.WorkflowNodeActionTypes.ADD_NODE:
            return workflowNodeAdapter.addOne(action.node, state);

        case actions.WorkflowNodeActionTypes.ADD_NODES:
            return workflowNodeAdapter.addMany(action.nodes, state);

        case actions.WorkflowNodeActionTypes.UPSERT_NODE:
            return workflowNodeAdapter.upsertOne(action.node, state);

        case actions.WorkflowNodeActionTypes.UPSERT_NODES:
            return workflowNodeAdapter.upsertMany(action.nodes, state);

        case actions.WorkflowNodeActionTypes.UPDATE_NODE:
            return workflowNodeAdapter.updateOne(action.node, state);

        case actions.WorkflowNodeActionTypes.UPDATE_NODES:
            return workflowNodeAdapter.updateMany(action.nodes, state);

        case actions.WorkflowNodeActionTypes.DELETE_NODE:
            return workflowNodeAdapter.removeOne(action.id, state);

        case actions.WorkflowNodeActionTypes.DELETE_NODES:
            return workflowNodeAdapter.removeMany(action.ids, state);

        case actions.WorkflowNodeActionTypes.DELETE_ALL:
            return workflowNodeAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getWorkflowNodeState = createFeatureSelector<WorkflowNodeState>('workflowNode');

export const { selectIds, selectEntities, selectAll, selectTotal } = workflowNodeAdapter.getSelectors(getWorkflowNodeState);

const getSelectedNodeIdState = (state: WorkflowNodeState) => state.selected_node_id;
export const getSelectedNodeId = createSelector(getWorkflowNodeState, getSelectedNodeIdState);

export const getSelectedNode = createSelector(getWorkflowNodeState, (state: WorkflowNodeState) => {
    if (state.selected_node_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_node_id];
});
